import { opaccAjaxPlugin, opaccLocalStoragePlugin } from '../opacc.static.js';
/** @module struct */

/**
 * Trefferliste Layoutumschaltung und Sortierung ändern
 *
 */
export class OpaccStruct {
	constructor() {
		this.wrapperElement = document.querySelector('.content');
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		this.switchStyle();
		this.sortList();
	}

	/**
	 *
	 *
	 */
	switchStyle() {
		this.wrapperElement.addEventListener('click', e => {
			let catStructListLayoutWrapper = e.target.closest('.opc-catstruct-list-layout');
			if (catStructListLayoutWrapper) {
				let switchStyleSelector = 'button.opc-button';
				let targetList = catStructListLayoutWrapper.dataset.opTarget;
				let items = catStructListLayoutWrapper.children;
				Array.from(items).some( item => {
					item.classList.remove('is-active');
					if (item == e.target.closest(switchStyleSelector)) {
						item.classList.add('is-active');
						e.currentTarget.querySelector(targetList).setAttribute('data-op-article-list-type', item.dataset.opLayout);
						this.setSelectedLayout(item.dataset.opLayout);
						opaccLocalStoragePlugin.setPersistentView(opaccLocalStoragePlugin.getCurrentURI(), '.result-view-wrapper');
					}
				});
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} layout
	 */
	setSelectedLayout(layout) {
		let data = { action: 'start', selectedStructLayout: layout };
		let url = location.href;
		opaccAjaxPlugin.fetchAsynPostForm(url, data);
	}

	/**
	 *
	 *
	 */
	sortList() {
		this.wrapperElement.addEventListener('change', e => {
			let catStructListSortWrapper = e.target.closest('.article-list-sort');
			if (catStructListSortWrapper) {
				let currentTarget = catStructListSortWrapper.querySelector('.opc-catsort');
				opaccAjaxPlugin.fetchAsynPostForm(currentTarget.dataset.opAction, this.prepareDataForSubmission(e.target), this.refreshResultList.bind(this, currentTarget), this.getDefaultErrorFnc, true);
			}
		});
	}

	/**
	 * Change-Event triggern, um asynchrone Change-Operationen auszuführen
	 * @private
	 * @ignore
	 */
	firePseudoChangeEvent() {
		let triggerEvent = new Event('change');
		document.querySelector('.content').dispatchEvent(triggerEvent);
	}

	resetPagination() {

	}

	/**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */
	prepareDataForSubmission(item) {
		let data = {
			[item.name]: item.options[item.options.selectedIndex].value,
			originalUrl: window.location.href
		};
		return data;
	}

	/**
	 *
	 *
	 * @param {*} target
	 * @param {*} response
	 */
	refreshResultList(target, response) {
		let targetSelector = target.dataset.opTarget;
		let pagingSelector = '.opc-segment-navigation .opc-button[data-op-href]';

		let htmlObj = document.createElement('div');
		htmlObj.innerHTML = response.dataAsHtml;
		document.querySelector(targetSelector).innerHTML = htmlObj.querySelector(targetSelector).innerHTML;

		// reset Paging
		let pagingElement = document.querySelector(pagingSelector) || null;
		if (pagingElement) {
			pagingElement.outerHTML = htmlObj.querySelector(pagingSelector).outerHTML;
		}

		opaccLocalStoragePlugin.removePersistentView(opaccLocalStoragePlugin.getCurrentURI());

		this.firePseudoChangeEvent();
	}
}